import {createContext} from 'react';

import type React from 'react';
import type {Context} from 'react';


export type AutosuggestContextType = {
    onItemSelect: (value: unknown, reason: 'MOUSE_DOWN' | 'ENTER', event?: Event) => void,
    itemsValuesOrder: React.RefObject<unknown[]>,
    onMountItem: (() => void) | (() => undefined),
    onUnmountItem: (() => void) | (() => undefined),
};

const DEFAULT_CONTEXT: AutosuggestContextType = {
    onItemSelect: () => {},
    itemsValuesOrder: {current: []},
    onMountItem: () => undefined,
    onUnmountItem: () => undefined,
};

export const AutosuggestContext: Context<AutosuggestContextType> =
    createContext<AutosuggestContextType>(DEFAULT_CONTEXT);

AutosuggestContext.displayName = 'AutosuggestContext';
